var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMembershipsStart = function SvgMembershipsStart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59818 5.90629L9.59816 5.90627L1.8217 0.582533L1.82163 0.582487C1.48837 0.354175 1.17531 0.25 0.941175 0.25C0.724996 0.25 0.564879 0.332922 0.451695 0.482096C0.332398 0.639326 0.25 0.891832 0.25 1.24784V12.754C0.25 13.1095 0.332286 13.3616 0.45131 13.5185C0.564225 13.6673 0.723893 13.75 0.939362 13.75C1.17309 13.75 1.48022 13.6464 1.81523 13.4168L1.8154 13.4166L9.59532 8.09313L9.59818 5.90629ZM9.59818 5.90629C10.0479 6.21408 10.2642 6.60522 10.2641 6.99932V6.99938M9.59818 5.90629L10.2641 6.99938M10.2641 6.99938C10.2641 7.39301 10.0455 7.78453 9.59548 8.09302L10.2641 6.99938Z",
    strokeWidth: 0.5
  }))));
};
export default SvgMembershipsStart;